import { ReactNode } from 'react'
import clsx from 'clsx'

interface CardProps {
  children: ReactNode
  className?: string
  title?: string
  subtitle?: string
  actions?: ReactNode
  noPadding?: boolean
  variant?: 'default' | 'outlined' | 'elevated'
}

export default function Card({
  children,
  className,
  title,
  subtitle,
  actions,
  noPadding = false,
  variant = 'default'
}: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-lg',
        {
          'bg-surface-800 border border-surface-700': variant === 'default',
          'border border-surface-600 bg-transparent': variant === 'outlined',
          'bg-surface-800 shadow-lg shadow-black/20': variant === 'elevated',
        },
        !noPadding && 'p-4',
        className
      )}
    >
      {(title || actions) && (
        <div className="card-header">
          <div>
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && (
              <p className="text-xs text-surface-500 mt-0.5">{subtitle}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  )
}
